// api.js

import axiosInstance from "../axiosInstance";

export const inventoryConfigService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/inventory-config", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, clientId, searchValue, product) => {
    try {
      let response = await axiosInstance.get(
        `/inventory-config?$limit=${limit || 15}&$skip=${skip || 0}&${
          clientId ? `client_id=${clientId}` : ""
        }&${searchValue ? `&sku[$search]=${searchValue}` : ""}&${
          product ? `product=${product}` : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(`/inventory-config/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/inventory-config/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchBySkuListAndClientAndSupplier: async (skus, client, supplier) => {
    try {
      let api = `/inventory-config?client=${client}&supplier=${supplier}&`;
      if (skus.length) {
        api += skus.map((x) => `sku[$in][]=${x}`).join("&");
      }

      let response = await axiosInstance.get(api);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
};
